import { gql } from "graphql-request";

export const buscarInscritoEidu = gql`
  query inscritoEidu($identificacion: String!) {
    inscritoEidu(identificacion: $identificacion) {
      id
      nombre
      identificacion
      pais
      correoInstitucional
      telefono
      unidad
      carrera
      universidad
      tieneDiscapacidad
      tipoDiscapacidad
      requiereApoyo
      detalleApoyo
      matriculadoSet {
        id
        grupo {
          id
          nombre
          cupoDisponible
        }
      }
    }
  }
`;

export const asignarTallerEidu = gql`
  mutation asignarTallerEidu($idDocente: Int!, $grupo: Int) {
    asignarTallerEidu(idDocente: $idDocente, grupo: $grupo) {
      docente {
        id
        nombre
      }
      matriculado {
        id
        grupo {
          id
          nombre
        }
      }
      success
    }
  }
`;
